import { z } from "zod";
import { entityBaseSchema } from "./common.js";

/**
 * Capability frontmatter — groups outlines by product area.
 * Mirrors `capabilities` table in cloud schema.
 */
export const capabilityFrontmatterSchema = entityBaseSchema.extend({
  /** Human-readable title; corresponds to cloud `name`. */
  title: z.string().min(1),
  description: z.string().nullish(),
  /**
   * Route patterns owned by this capability (e.g. `["/billing", "/invoices"]`).
   * Evaluated with segment-boundary Longest Prefix Match against surface places.
   */
  paths: z.array(z.string()).default([]),
  /** Optional visual grouping category (e.g. "Finance", "Administration"). */
  area: z.string().nullish(),
});

export type CapabilityFrontmatter = z.infer<typeof capabilityFrontmatterSchema>;
